export default "__VITE_ASSET__CN9s7FTw__"